/* eslint-disable prefer-arrow-callback */
/* eslint-disable strict */
(function ($) {
  "use strict";

  $(function () {
    // Check if we're on the agents portal login page
    if (!$(".login__form").length) {
      return;
    }

    // Handle form submission
    $(".login__form").on("submit", function (e) {
      e.preventDefault();

      const $form = $(this);
      const $emailInput = $form.find("#email");
      const $formGroup = $emailInput.closest(".form-group");
      const $submitButton = $form.find('button[type="submit"]');
      const emailValue = $emailInput.val().trim();
      const agentPortalUrl = $form.find('input[name="agent_portal_url"]').val();

      // Reset error state
      $formGroup.removeClass("is-error");

      // Basic validation
      if (!emailValue) {
        $formGroup.addClass("is-error");
        return;
      }

      // Basic email format validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailValue)) {
        $formGroup.addClass("is-error");
        return;
      }

      // Disable submit button during request
      $submitButton.prop("disabled", true).addClass("is-loading");

      // Get current language
      const currentLang = $.langCookie || "hu";

      // Localized messages
      const messages = {
        hu: {
          success: {
            title: "Bejelentkezési link elküldve!",
            subtitle:
              "Kérjük, ellenőrizd a postaládádat és kattints a bejelentkezési linkre.<br>A link <strong>20 percig érvényes</strong>.",
          },
          errors: {
            EMAIL_REQUIRED: "Kérjük, add meg az email címed.",
            INVALID_EMAIL: "Érvénytelen email cím formátum.",
            NOT_AUTHORIZED:
              "Ez az email cím nem jogosult megtekinteni az oldalt. Ha úgy gondolod, hogy ez hiba, kérjük vedd fel velünk a kapcsolatot.",
            EMAIL_SEND_FAILED:
              "Az email küldése sikertelen. Kérjük, próbáld újra később.",
            SERVER_ERROR: "Szerverhiba történt. Kérjük, próbáld újra később.",
            NETWORK_ERROR:
              "Hálózati hiba történt. Kérjük, ellenőrizd az internetkapcsolatod.",
            UNKNOWN_ERROR: "Ismeretlen hiba történt. Kérjük, próbáld újra.",
          },
        },
        en: {
          success: {
            title: "Login link sent!",
            subtitle:
              "Please check your mailbox and click on the login link.<br>The link is <strong>valid for 20 minutes</strong>.",
          },
          errors: {
            EMAIL_REQUIRED: "Please enter your email address.",
            INVALID_EMAIL: "Invalid email address format.",
            NOT_AUTHORIZED:
              "This email address is not authorized to access this page. If you believe this is an error, please contact us.",
            EMAIL_SEND_FAILED: "Failed to send email. Please try again later.",
            SERVER_ERROR: "Server error occurred. Please try again later.",
            NETWORK_ERROR:
              "Network error occurred. Please check your internet connection.",
            UNKNOWN_ERROR: "Unknown error occurred. Please try again.",
          },
        },
      };

      // Make API call
      cordiaAPI
        .post("/agents/request-login", {
          email: emailValue,
          lang: currentLang,
          agent_portal_url: agentPortalUrl,
        })
        .then(function (response) {
          console.log("Agent Request Login Response:", response.data);

          const { error } = response.data;

          if (error) {
            $.showError(messages[currentLang].errors[error]);
            $submitButton.prop("disabled", false).removeClass("is-loading");
            return;
          }
          if (response.data.success === true) {
            $form.fadeOut(300, function () {
              // Create success message element
              const $result = $(
                '<div class="login__result login__result--success"></div>'
              );

              const successMsg = messages[currentLang]
                ? messages[currentLang].success
                : messages.hu.success;

              const $title = $(
                '<h2 class="login__result-title" style="margin-bottom: 16px;"></h2>'
              ).text(successMsg.title);
              const $subtitle = $(
                '<p class="login__result-subtitle"></p>'
              ).html(successMsg.subtitle);

              $result.append($title).append($subtitle);

              // Insert result after the form
              $form.after($result);

              // Fade in the result
              $result.hide().fadeIn(300);
            });
          }
        })
        .catch((error) => {
          console.error("Agent Request Login Error:", error);
        });
    });
  });
})(jQuery);
